import { useSyncExternalStore } from "react";

/*
 * Layout modes (Galaxy Z Fold: cover screen ≈ 360–420 CSS px wide, inner screen ≈ 700–900):
 *   wide    ≥ 1000  sidebar | list | note
 *   compact 700–999 icon rail | list | note
 *   narrow  < 700   icon rail | list OR note (single pane)
 * State lives in the URL, so folding/unfolding keeps the open note.
 */
export type LayoutMode = "wide" | "compact" | "narrow";

function mode(): LayoutMode {
  const w = window.innerWidth;
  return w >= 1000 ? "wide" : w >= 700 ? "compact" : "narrow";
}

let current: LayoutMode = typeof window !== "undefined" ? mode() : "wide";
const listeners = new Set<() => void>();
if (typeof window !== "undefined") {
  window.addEventListener("resize", () => {
    const m = mode();
    if (m !== current) {
      current = m;
      for (const l of listeners) l();
    }
  });
}

export function useLayout(): LayoutMode {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
  );
}
